module.exports = __webpack_public_path__ + "static/media/LOGO_TS-1.ea9ea763.svg";